import api from './api';

export interface Driver {
  id: number;
  userId: string;
  approved: 'P' | 'A' | 'R';
  vehicleType: string;
  biNumero?: string;
  cartaConducao?: string;
  vehiclePlate?: string;
  vehicleModel?: string;
  biDocUrl?: string;
  cartaDocUrl?: string;
  avatarUrl?: string;
  rejectionReason?: string;
  approvedAt?: string;
  createdAt: string;
  totalDeliveries: number;
  rating: number;
  ratingCount?: number;
  termosVersao?: string | null;     // versão do Contrato do Estafeta aceite
  termosAceitesEm?: string | null;
  online: number;
  email: string;
  name: string;
  phone?: string;
}

const driversService = {
  list: (status?: 'P' | 'A' | 'R') =>
    api.get<{ success: boolean; data: Driver[] }>(`/food/admin/drivers${status ? `?status=${status}` : ''}`),

  /** Documento privado (BI/carta), pedido com a sessão do administrador. */
  getDoc: (id: number, kind: 'bi' | 'carta') =>
    api.get<Blob>(`/food/admin/drivers/${id}/doc/${kind}`, { responseType: 'blob' }),

  approve: (id: number) =>
    api.put(`/food/admin/drivers/${id}/approve`),

  reject: (id: number, reason: string) =>
    api.put(`/food/admin/drivers/${id}/reject`, { reason }),

  /** Registo feito pela Pagali: conta + ficha já aprovada (multipart, documentos opcionais). */
  create: (dados: FormData) =>
    api.post('/food/admin/drivers', dados, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export default driversService;
